const TRANSPORT_INFO_TYPES = {
  STATUS: "status",
  PENDING: "PENDING",
  DONE: "DONE",
  BLOCKED: "BLOCKED",
  RELEASED: "RELEASED"
};

export { TRANSPORT_INFO_TYPES };
